(function () {
    console.log("store verification init");
    const COOKIE_NAME = "selected_store";
    const COOKIE_DAYS = 30;
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 86400000));
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1];
    }

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const redirect = urlParams.get('redirect');

    if(redirect)
    {
        setCookie(COOKIE_NAME, "ca", COOKIE_DAYS);
        const currentUrl = new URL(window.location.href);
        currentUrl.search = '';
        window.history.replaceState({}, document.title, currentUrl.toString());
        return true;
    }

    const selectedStore = getCookie(COOKIE_NAME);
    const overlay = document.getElementById('storeVerifyOverlay');

    if(!selectedStore)
    {
        overlay.style.display = "flex";
    }
    else
    {
        overlay.style.display = "none";
    }

    document.querySelectorAll('[data-store]').forEach(button => {
        button.addEventListener('click', function () {
        store = this.getAttribute('data-store');
        setCookie(COOKIE_NAME, store, COOKIE_DAYS);

        // Redirect based on store
        if (store === 'us') {
            window.location.href = 'https://vykoncustoms.com?redirect=true';
        } else {
            overlay.style.display = "none";
        }
        });
    });

    if (Shopify.designMode) {
        overlay.style.display = "none";
    }

})();